var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedKingdomFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_196_9170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.831884 12H15.1681C15.629 11.9719 16 11.5562 16 11.0531V0.946875C16 0.428125 15.6087 0.003125 15.1275 0H0.872464C0.391304 0.003125 0 0.428125 0 0.946875V11.05C0 11.5563 0.371014 11.9719 0.831884 12Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88116 7.19688V12H9.10725V7.19688H16V4.79688H9.10725V0H6.88116V4.79688H0V7.19688H6.88116Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84937 3.88437V0H15.1334C15.4986 0.00625 15.8117 0.253125 15.9392 0.6L9.84937 3.88437Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84937 8.1156V12H15.1682C15.5189 11.9781 15.8146 11.7344 15.9392 11.4L9.84937 8.1156Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13905 8.1156V12H0.831805C0.481081 11.9781 0.18253 11.7344 0.060791 11.3937L6.13905 8.1156Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13905 3.88437V0H0.866588C0.501371 0.00625 0.185429 0.25625 0.060791 0.60625L6.13905 3.88437Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.99998H2.21739L0 2.8031V3.99998Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4H13.771L16 2.79688V4Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8H13.771L16 9.20313V8Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8H2.21739L0 9.19687V8Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.01562L10.4783 4H11.7131L16 1.6875V1.01562Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51014 8H4.27536L0 10.3062V10.9781L5.52174 8H5.51014Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04928 4.00317H4.28406L0 1.69067V2.35942L3.04928 4.00317Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9362 7.99683H11.7014L16 10.3187V9.64995L12.9362 7.99683Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_9170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdomFlag);
export default __webpack_public_path__ + "static/media/united-kingdom-flag.4ff8afe560b31ca63676047eebf7812d.svg";
export { ForwardRef as ReactComponent };